// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { PageMetadata, PageMetadataSchema } from 'api/gen/PageMetadata';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { UserProfileSubjectRoleManagementDtoOtherSubjectRoleManagement, UserProfileSubjectRoleManagementDtoOtherSubjectRoleManagementSchema } from 'api/gen/UserProfileSubjectRoleManagementDtoOtherSubjectRoleManagement';

const requiredPart = t.interface({
  content: t.union([t.array(UserProfileSubjectRoleManagementDtoOtherSubjectRoleManagementSchema), t.null]),
  page: t.union([PageMetadataSchema, t.null]),
});

export const PagedModelUserProfileSubjectRoleManagementDtoOtherSubjectRoleManagementSchema = excess(requiredPart);

export interface PagedModelUserProfileSubjectRoleManagementDtoOtherSubjectRoleManagement extends t.TypeOf<typeof PagedModelUserProfileSubjectRoleManagementDtoOtherSubjectRoleManagementSchema> {}
